import { c as _c } from "react/compiler-runtime";
import { useQuery } from '@tanstack/react-query';
import type { GlobalSettings, GlobalSettingsKey } from '@sola/schema/dotcom/shared/content/settings.ts';
import { getSettings, getSettingsByKey } from './utils/routes';

/**
 * React Query hook for fetching content settings.
 * @returns The result of the query
 */
export const useContentSettings = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      queryKey: ["contentSettings"],
      queryFn: _temp,
      refetchOnWindowFocus: false,
      staleTime: Infinity
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return useQuery(t0);
};

/**
 * React Query hook for fetching a single content setting by key.
 * Uses SDG's `/settings/{key}` endpoint so the client only downloads when it needs.
 */
export const useContentSettingsValue = key => {
  const $ = _c(2);
  let t0;
  if ($[0] !== key) {
    t0 = {
      queryKey: ["contentSettings", key],
      queryFn: () => getSettingsByKey(key),
      refetchOnWindowFocus: false,
      staleTime: Infinity
    };
    $[0] = key;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return useQuery(t0);
};
function _temp() {
  return getSettings();
}